import { render, staticRenderFns } from "./testo.vue?vue&type=template&id=16704fd2"
import script from "./testo.vue?vue&type=script&lang=js"
export * from "./testo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16704fd2')) {
      api.createRecord('16704fd2', component.options)
    } else {
      api.reload('16704fd2', component.options)
    }
    module.hot.accept("./testo.vue?vue&type=template&id=16704fd2", function () {
      api.rerender('16704fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/testo.vue"
export default component.exports